import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 40,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 4a3 3 0 013-3h11.93a4 4 0 012.83 1.17l11.07 11.07A4 4 0 0131 16.07V36a3 3 0 01-3 3H4a3 3 0 01-3-3V4z",
		fill: "#fff",
		stroke: "#0E4EFB",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M29.59 13H22a3 3 0 01-3-3V2.41L29.59 13z",
		fill: "#fff",
		stroke: "#0E4EFB",
		strokeWidth: 2
	})]
});
export default SvgDocument;
